@import '~less/global-variables';

.guide-header {
  padding-top: 130px;
  padding-bottom: 50px;
  &.board-happyhippies {
    background-position: 50% 30%;
  }
  @media (min-width: @screen-sm-min) {
    padding-top: 260px;
    padding-bottom: 200px;
  }
}
